(() => {
  class PortalJourney extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const list = this.querySelector('[data-portal-tabs]');
      const tabs = [...this.querySelectorAll('[data-portal-tab]')];
      const panels = [...this.querySelectorAll('[data-portal-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      this.initialized = true;
      list.hidden = false;
      list.setAttribute('role', 'tablist');
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {event.preventDefault(); select(next, true);}
        });
      });
      select(0);
    }
  }
  if (!customElements.get('nordsign-portal-journey')) customElements.define('nordsign-portal-journey', PortalJourney);
})();
